import { z } from 'zod';

import { AddressZod } from 'types/zod/address';
import { AddressTypeZod } from 'types/zod/address-type';
import { ObserverRelationshipZod } from 'types/zod/observer-relationship';
import { SystemRoleZod } from 'types/zod/system-role';
import { UserZod } from 'types/zod/user';

const ParticipantTypeCodeZod = z.union([z.literal('Individual'), z.literal('Charity'), z.literal('Trust')]);

export const ParticipantZod = z.object({
    address: z.record(AddressTypeZod, AddressZod).optional(),
    administratedGroups: z.union([z.null(), z.array(z.number())]).optional(),
    approx_age: z.number().nullable().optional(),
    aws_id: z.string().optional(),
    company: z.string().optional(),
    date_of_birth: z.string().nullable().optional(),
    domicile_state_code: z.string().optional(),
    editable: z.boolean(),
    email: z.string().optional(),
    first_name: z.string().optional(),
    full_name: z.string().optional().nullable(),
    last_name: z.string().optional(),
    middle_name: z.string().optional(),
    minor: z.boolean().optional(),
    observer_relationship: ObserverRelationshipZod.optional(),
    organization_name: z.union([z.string(), z.null()]).optional(),
    parentGroupId: z.number().nullable().optional(),
    participant_id: z.number(),
    participant_type_code: ParticipantTypeCodeZod.optional(),
    phone_number: z.string().optional(),
    signed_up: z.boolean().optional(),
    suffix: z.string().optional(),
    systemRoles: SystemRoleZod.array().optional(),
    user: UserZod.optional(),
    date_added: z.number().optional(),
    date_modified: z.number().optional(),
});

export type Participant = z.infer<typeof ParticipantZod>;
